export const APP_NAME = 'GT Hoildays'
export const PERSIST_STORE_NAME = 'admin'
export const REDIRECT_URL_KEY = 'redirectUrl'

export const CUSTOMISABLE_TOUR = 'customisable'
export const NON_CUSTOMISABLE_TOUR = 'non_customisable'
export const GROUP_TOUR = 'group'
